/**
 * Created by r4zi4l on 16.05.2022
 */

const Prizes = {};

Prizes.Generate = function (config, options) {
    options = options || {};
    let prizes = [];

    config.forEach((block) => {
        let amount = block.amount || 1;
        let p = block.probabilities || [];
        let units = block.units || [block];

        if (block.resource || block.ingredient) {
            block = { ...block };

            if (Array.isArray(block.amount)) {
                block.amount = PseudoRandom.GET().random(block.amount[0], block.amount[1]);
            }

            amount = 1;
            p = [];
            units = [block];
        }

        prizes = prizes.concat(options.listOnly ? units : PseudoRandom.GET().probability(amount, p, units));
    });

    prizes = prizes.map((unit) => {
        if (unit.resource || unit.ingredient || unit.lock) {
            return unit;
        }

        let code = unit.code;
        let stage = unit.stage;
        let maxStage = unit.maxStage;

        if (unit.currentType) {
            code = cleverapps.unitsLibrary.getCurrentOfType(unit.currentType);
            if (code && unit.currentType.indexOf("hero") !== -1 && Families[code].units.length === 1) {
                code = undefined;
            }
        } else if (unit.openedType) {
            const availableUnits = [];

            cleverapps.unitsLibrary.listCodesByType(unit.openedType).forEach((code) => {
                cleverapps.unitsLibrary.listOpened(code).forEach((unit) => {
                    availableUnits.push(unit);
                });
            });

            const selectedUnit = PseudoRandom.GET().choose(availableUnits);
            code = selectedUnit.code;
            stage = unit.stage === undefined ? selectedUnit.stage : unit.stage;
        } else if (unit.type) {
            code = PseudoRandom.GET().choose(cleverapps.unitsLibrary.listAvailableByType(unit.type));
        }

        if (!code) {
            code = "coins";
            stage = stage && Math.min(3, stage);
            maxStage = maxStage && Math.min(3, maxStage);
        }

        if (stage === undefined && maxStage) {
            stage = Math.min(Math.floor(PseudoRandom.GET().nextDouble() * maxStage), Families[code].units.length - 1);
        }

        if (!Families[code]) {
            return;
        }

        return Prizes.decreasePrizeStageIfNeeded({
            code,
            stage
        });
    });

    prizes = prizes.filter((unit) => {
        if (!unit) {
            return false;
        }

        if (unit.resource) {
            return true;
        }

        if (unit.ingredient) {
            return Map2dLocation.currentLocation.harvested.isIngredientAvailable(unit.ingredient);
        }

        const type = Families[unit.code].type;

        if (type === "hero" && cleverapps.gameLevel.getLevel() < 3) {
            return false;
        }

        if (type === "snailfeast") {
            if (!cleverapps.missionManager.findRunningMission(Mission.CompoundType(Mission.TYPE_SNAIL_FEAST, cleverapps.meta.selectedLocationId()))) {
                return false;
            }
        }

        if (unit.code === "magicplant" && cleverapps.gameLevel.getLevel() < 6) {
            return false;
        }

        return true;
    });

    return prizes;
};

Prizes.decreasePrizeStageIfNeeded = function (prize) {
    const code = prize.code;
    let stage = prize.stage;

    if (!Families[code]) {
        cleverapps.throwAsync(`Prizes.decreasePrizeStageIfNeeded wrong code - ${code}`);
        return {
            code,
            stage
        };
    }

    if (code && stage > 0) {
        if (["hero", "drhero", "seahero"].indexOf(Families[code].type) !== -1) {
            stage = Math.min(stage, Families[code].units.length - 2);
        }

        if (["resource"].indexOf(Families[code].type) !== -1) {
            stage = Math.min(stage, Families[code].units.length - 3);
        }

        if (["resource", "hero"].indexOf(Families[code].type) !== -1) {
            while (stage > 0 && !cleverapps.unitsLibrary.isOpened({ code, stage })) {
                stage--;
            }
        }

        stage = Math.min(stage, Families[code].units.length - 1);

        if (stage < 0) {
            stage = 0;
        }
    }

    return {
        code,
        stage
    };
};
